// context/LocaleContext.tsx
import React, { createContext, ReactNode, useContext, useState } from 'react';
import { NotificationContextType } from '../../interfaces/types/NotificationContextType';
import { getQtdMensagemNaoLida } from '../../services/ComunicadoService';

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

interface NotiticationProviderProps {
    children: ReactNode;
}

export const NotificationProvider: React.FC<NotiticationProviderProps> = ({ children }) => {
    const [unreadNotificationsNumber, setUnreadNotificationsNumber] = useState<number>(0);

    const getUnreadNotificationsNumber = async (): Promise<number> => {
        return new Promise((resolve, reject) => {
          getQtdMensagemNaoLida('todos')
            .then(result => {
              if (result !== null) {
                let unreadNotificationsNumber = 0;
                result.forEach(message => {
                    unreadNotificationsNumber = unreadNotificationsNumber + message.qtdNaoLido;
                })
                resolve(unreadNotificationsNumber);
              }
            })
            .catch(error => {
              reject(error);
            })
        })
      };

    const updateUnreadNotificationsNumber = async (): Promise<void> => {
        const unread = await getUnreadNotificationsNumber();
        setUnreadNotificationsNumber(unread);
        return;
    }

    return (
        <NotificationContext.Provider value={{ unreadNotificationsNumber, updateUnreadNotificationsNumber }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};
